import React, {useState, useEffect,} from 'react';
import { BrowserRouter, Routes, Route, useLocation} from 'react-router-dom';


import Main from 'page/Main';
import Food from 'page/Food';
import GsFellowship from 'page/GsFellowship';
import Girls from 'page/Girls';
import Login from 'page/Login';
import Diary from 'page/Diary';
import Body from 'page/Body';
import Chat from 'page/Chat';
import Lotto from 'page/Lotto';



export const common = [
    {path:'/', element : <Food/>}
    , {path:'/Food', element : <Food/>}
    , {path:'/gsFellowship', element : <GsFellowship/>}
    , {path:'/girls', element : <Girls/>}
    , {path:'/login', element : <Login/>}
    , {path:'/diary', element : <Diary/>}
    , {path:'/chat', element : <Chat/>}
    , {path:'/body', element : <Body/>}
    , {path:'/lotto', element : <Lotto/>}
];